var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 12.04C15.4002 11.1716 15.6302 10.3199 16.0587 9.56448C16.4871 8.80904 17.1 8.17448 17.84 7.72002C17.3698 7.05 16.7499 6.49873 16.0296 6.10991C15.3092 5.7211 14.5082 5.50544 13.69 5.48002C11.94 5.29002 10.25 6.48002 9.36004 6.48002C8.47004 6.48002 7.08004 5.48002 5.61004 5.48002C4.65521 5.50993 3.72434 5.78624 2.90782 6.28211C2.0913 6.77798 1.41688 7.47656 0.950041 8.31002C-1.04996 11.8 0.44004 16.91 2.37004 19.73C3.37004 21.11 4.46004 22.64 5.93004 22.59C7.40004 22.54 7.93004 21.67 9.66004 21.67C11.39 21.67 11.89 22.59 13.39 22.56C14.89 22.53 15.91 21.17 16.84 19.78C17.5226 18.8129 18.0459 17.7426 18.39 16.61C17.4957 16.2281 16.7339 15.5908 16.2003 14.7778C15.6666 13.9649 15.3848 13.0125 15.39 12.04Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 3.63C13.3903 2.61484 13.8059 1.31431 13.71 0C12.4267 0.136206 11.2415 0.750202 10.39 1.72C9.9711 2.19638 9.65034 2.75077 9.44613 3.35138C9.24192 3.95199 9.15829 4.587 9.20001 5.22C9.84201 5.22387 10.4766 5.08291 11.0566 4.80763C11.6366 4.53235 12.1471 4.12982 12.55 3.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.60ce27c597ddcbedb4973d4236807421.svg";
export { ForwardRef as ReactComponent };